<template>
    <ul class="navbar-nav mr-auto">
        <li class="nav-item">
            <router-link to="/overview" class="nav-link"><!--<font-awesome-icon icon="wifi" />--> Overview </router-link>
        </li>
        <li class="nav-item">
            <router-link to="/chart" class="nav-link"><!--<font-awesome-icon icon="wifi" />--> Chart </router-link>
        </li>
        <li class="nav-item">
            <router-link to="/console" class="nav-link"><!--<font-awesome-icon icon="wifi" />--> Console </router-link>
        </li>
    </ul>
</template>

<script>
  import { routes } from '../router/routes'

  export default {
    data() {
      return {
        routes,
        collapsed: false
      }
    },
    methods: {
      toggleCollapsed: function () {
        this.collapsed = !this.collapsed;
      }
    },
    created() {
      
    }
  }
</script>

<style>
  .slide-enter-active, .slide-leave-active {
    transition: max-height .35s
  }

  .slide-enter, .slide-leave-to {
    max-height: 0px;
  }

  .slide-enter-to, .slide-leave {
    max-height: 20em;
  }
</style>
